import _ from "lodash";
import React from "react";

// classes
import classes from "./CheckListWithDuration.scss";

import PropTypes from "prop-types";

// components
import GenericCheckList from "UIComponents/GenericCheckList";
import StepperInputField from "UIComponents/StepperInputField";
import UIBaseComponent from "UIComponents/UIBaseComponent";

class CheckListWithDuration extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  renderEdit = () => {
    const {
      updateInputField,
      fieldKey,
      disabled,
      displayDisabledAsActive,
      options: optionsMap,
      value: valuesMap,
      testId,
      fieldTypeConfig,
      styles,
      durationFieldUid,
      tooltipPosition,
      listItemStyle,
      regexString,
    } = this.props;

    const { checkListValue = [], durationValue = [] } = valuesMap;
    const { checkListOptions, durationOptions } = optionsMap;
    const { checkListStyles } = styles;
    const {
      informationIconSize,
      checkListContainerStyles,
      checkBoxLabelStyles,
    } = checkListStyles;

    return (
      <div className={classes.container}>
        {_.map(checkListOptions, checkListOption => {
          const { value, id } = checkListOption;
          const optionValue = _.includes(checkListValue, value) ? value : null;

          const durationOption = _.find(durationOptions, { id });
          const currentDurationValue = _.get(
            _.find(durationValue, { id }),
            "value",
            null
          );

          return (
            <div className={classes.rowContainer}>
              <GenericCheckList
                value={[optionValue]}
                options={[checkListOption]}
                name={fieldKey}
                updateInputField={value => {
                  updateInputField({
                    ...value,
                    option: checkListOption,
                    durationFieldUid,
                    currentFieldUid: fieldKey,
                    checkListFieldUid: fieldKey,
                    nodes: checkListOptions,
                  });
                }}
                testId={testId}
                informationIconSize={informationIconSize}
                CheckBoxLabelStyles={checkBoxLabelStyles}
                fieldTypeConfig={fieldTypeConfig}
                disabled={disabled}
                displayDisabledAsActive={displayDisabledAsActive}
                containerStyle={checkListContainerStyles}
                tooltipPosition={tooltipPosition}
                listItemStyle={listItemStyle}
                dsVersion="2.0"
                showSubtextUnderInfo={true}
              />
              <div>
                <StepperInputField
                  key={id}
                  value={currentDurationValue}
                  updateInputField={value =>
                    updateInputField({
                      [durationFieldUid]: value,
                      currentFieldUid: durationFieldUid,
                      option: durationOption,
                      checkListFieldUid: fieldKey,
                      durationFieldUid,
                      nodes: checkListOptions,
                    })
                  }
                  disabled={disabled}
                  testId={`${testId}-${id}`}
                  regexString={regexString}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
}

CheckListWithDuration.defaultProps = {
  ...UIBaseComponent.defaultProps,
  disabled: false,
  displayDisabledAsActive: false,
  options: {},
  value: {},
  testId: "",
  fieldTypeConfig: {},
  styles: {},
  maxLength: 5,
};

CheckListWithDuration.propTypes = {
  ...UIBaseComponent.propTypes,
  disabled: PropTypes.bool,
  displayDisabledAsActive: PropTypes.bool,
  options: PropTypes.object,
  value: PropTypes.object,
  testId: PropTypes.string,
  fieldTypeConfig: PropTypes.object,
  styles: PropTypes.object,
  maxLength: PropTypes.number,
};

export default CheckListWithDuration;
